/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PhotoAnalysisDecisionSource = {
    llm: 'llm',
    cv_fallback: 'cv_fallback'
} as const;
export type PhotoAnalysisDecisionSource = typeof PhotoAnalysisDecisionSource[keyof typeof PhotoAnalysisDecisionSource];


export function instanceOfPhotoAnalysisDecisionSource(value: any): boolean {
    for (const key in PhotoAnalysisDecisionSource) {
        if (Object.prototype.hasOwnProperty.call(PhotoAnalysisDecisionSource, key)) {
            if (PhotoAnalysisDecisionSource[key as keyof typeof PhotoAnalysisDecisionSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PhotoAnalysisDecisionSourceFromJSON(json: any): PhotoAnalysisDecisionSource {
    return PhotoAnalysisDecisionSourceFromJSONTyped(json, false);
}

export function PhotoAnalysisDecisionSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotoAnalysisDecisionSource {
    return json as PhotoAnalysisDecisionSource;
}

export function PhotoAnalysisDecisionSourceToJSON(value?: PhotoAnalysisDecisionSource | null): any {
    return value as any;
}

export function PhotoAnalysisDecisionSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): PhotoAnalysisDecisionSource {
    return value as PhotoAnalysisDecisionSource;
}

